export const LIMIT = 10;
export const SUPER_ADMIN = "super_admin";
export const STORE_OWNER = "store_owner";
export const STAFF = "staff";
export const OBSERVER = "observer";
export const CUSTOMER = "customer";
export const TOKEN = "token";
export const ROLES = "roles";
export const PERMISSIONS = "permissions";
export const AUTH_CRED = "AUTH_CRED";
export const PIN_AUTH_CRED = "PIN_AUTH_CRED";

export const VIEW_DASHBOARD = "view-dashboard";
export const VIEW_PRODUCT = "view-product";
export const EDIT_PRODUCT = "edit-product";
export const DELETE_PRODUCT = "delete-product";
export const VIEW_SEARCH_TERM = "view-search_term";
export const EDIT_SEARCH_TERM = "edit-search_term";
export const EDIT_CATEGORY = "edit-category";
export const DELETE_CATEGORY = "delete-category";
export const EDIT_TAG = "edit-tag";
export const VIEW_ORDER = "view-order";
export const EDIT_ORDER = "edit-order";
export const DELETE_ORDER = "delete-order";
export const VIEW_ADDRESS = "view-address";
export const EDIT_BANNER = "edit-banner";
export const DELETE_BANNER = "delete-banner";
export const SEARCH_BANNER = "search-banner";
export const VIEW_WALLET_GROUP = "view-wallet_group";
export const EDIT_WALLET_GROUP = "edit-wallet_group";
export const VIEW_WALLET_RULE = "view-wallet_rule";
export const EDIT_WALLET_RULE = "edit-wallet_rule";
export const DELETE_WALLET_RULE = "delete-wallet_rule";
export const VIEW_WALLET = "view-wallet";
export const VIEW_WALLET_TRANSACTION = "view-wallet_transaction";
export const VIEW_USER = "view-user";
export const VIEW_MEMBERSHIP = "view-membership";
export const EDIT_MEMBERSHIP = "edit-membership";
export const EDIT_USER = "edit-user";
export const DELETE_USER = "delete-user";
export const RESTORE_USER = "restore-user";
export const EDIT_CUSTOMER_GROUP = "edit-customer_group";
export const EDIT_ROLE_PERMISSION = "edit-role_permission";
export const VIEW_DISCOUNT = "view-discount";
export const EDIT_DISCOUNT = "edit-discount";
export const DELETE_DISCOUNT = "delete-discount";
export const EDIT_NOTIFICATION_TEMPLATE = "edit-notification_template";
export const EDIT_STATIC_BLOCK = "edit-static_block";
export const EDIT_SETTING = "edit-setting";
export const EDIT_TAX = "edit-tax";
export const VIEW_BRANCH = "view-branch";
export const EDIT_BRANCH = "edit-branch";
export const DELETE_BRANCH = "delete-branch";
export const EDIT_PAYMENT_GATEWAY = "edit-payment_gateway";
export const EDIT_PAYMENT_METHOD = "edit-payment_method";
export const EDIT_SHIPPING = "edit-shipping";
export const EDIT_STORES = "edit-stores";
export const VIEW_LOCATION = "view-location";
export const EDIT_LOCATION = "edit-location";
export const DELETE_LOCATION = "delete-location";
export const EDIT_ORDER_STATUS = "edit-order_status";
export const EDIT_BLOCKED_DOMAIN = "edit-blocked_domain";

export const ALL_PERMISSIONS = [
  VIEW_DASHBOARD,
  VIEW_PRODUCT,
  EDIT_PRODUCT,
  DELETE_PRODUCT,
  VIEW_SEARCH_TERM,
  EDIT_SEARCH_TERM,
  EDIT_CATEGORY,
  DELETE_CATEGORY,
  EDIT_TAG,
  VIEW_ORDER,
  EDIT_ORDER,
  DELETE_ORDER,
  VIEW_ADDRESS,
  EDIT_BANNER,
  DELETE_BANNER,
  SEARCH_BANNER,
  VIEW_WALLET_GROUP,
  EDIT_WALLET_GROUP,
  VIEW_WALLET_RULE,
  EDIT_WALLET_RULE,
  DELETE_WALLET_RULE,
  VIEW_WALLET,
  VIEW_WALLET_TRANSACTION,
  VIEW_USER,
  EDIT_USER,
  DELETE_USER,
  RESTORE_USER,
  EDIT_CUSTOMER_GROUP,
  EDIT_ROLE_PERMISSION,
  VIEW_DISCOUNT,
  EDIT_DISCOUNT,
  DELETE_DISCOUNT,
  EDIT_NOTIFICATION_TEMPLATE,
  EDIT_STATIC_BLOCK,
  EDIT_SETTING,
  EDIT_TAX,
  VIEW_BRANCH,
  EDIT_BRANCH,
  DELETE_BRANCH,
  EDIT_PAYMENT_GATEWAY,
  EDIT_PAYMENT_METHOD,
  EDIT_SHIPPING,
  VIEW_LOCATION,
  EDIT_LOCATION,
  DELETE_LOCATION,
  EDIT_ORDER_STATUS,
  EDIT_BLOCKED_DOMAIN,
];
